module.exports = "pegasus_template/assets/blue-ghost-twitter.png";